// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withHandlers, compose } from '../../../../../../../node_module_clones/recompose';
import { createSelector } from 'reselect';
import classNames from 'classnames';

// Actions
import { setSelectedNotification } from '../notificationsPopupActions';

// Selector
import { getGroupPopupId } from './notificationOptOutPopupUtils';
import { activePopupSelector } from '../../../../../../components/popupPanel/popupOpenSelector';
import { getSelectedNotificationId } from '../notificationsPopupSelector';

// Components
import PopupToolButton from '../../../../../../components/popupPanel/PopupToolButton';
import Icon from '../../../../../../components/icons/Icon';

// Styles
import './NotificationGroupToolsOptOutUtil.scss';

const preventClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
};

const mapStateToProps = () =>
    createSelector(
        activePopupSelector,
        getSelectedNotificationId,
        (prop, ownProps) => ownProps.notificationId,
        (prop, ownProps) => ownProps.group,
        (activePopupState, selectedNotificationId, notificationId, group) => {
            const popupId = getGroupPopupId(group);
            const isOptOutPopupOpen = activePopupState.has(popupId);

            return {
                forceShowUtil: isOptOutPopupOpen && selectedNotificationId === notificationId,
            };
        },
    );

const mapDispatchToProps = (dispatch) => ({
    dispatchTogglePopup: (args) => {
        dispatch(setSelectedNotification(args));
    },
});

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withHandlers({
        togglePopup: (props) => (popupIsOpen) => {
            const { group, dispatchTogglePopup } = props;
            dispatchTogglePopup({ group });
        },
    }),
);

const NotificationGroupToolsOptOutUtil = (props) => {
    const popupId = getGroupPopupId(props.group);

    return (
        <div
            id={getGroupPopupId(props.group)}
            className={classNames('NotificationGroupToolsOptOutUtil', { 'force-show': props.forceShowUtil })}
            onClick={preventClick}
        >
            <PopupToolButton popupId={popupId} icon={<Icon name="more-ellipsis" />} onToggle={props.togglePopup} />
        </div>
    );
};

NotificationGroupToolsOptOutUtil.propTypes = {
    group: PropTypes.object,
    boardId: PropTypes.string,
    togglePopup: PropTypes.func,
    dispatchTogglePopup: PropTypes.func,
    forceShowUtil: PropTypes.bool,
};

export default enhance(NotificationGroupToolsOptOutUtil);
